import { memo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import CurveInfoBox from "./curveInfoBox";
import { ProgressBar } from "../../..";
import { ProgressTypes } from "../../../ProgressViewer/_ProgressViewer/progressDefinitions";
import { useAppDispatch, useAppSelector } from "../../../../Store";
import { dispatchFetchByFilter, selectConsumptionById } from "../../../../Services/Agrisys_GqlDataCaller/ConsumptionCalls/consumptionSlice";

const InfoBoxUsage = memo(({ feedCurveId }: { feedCurveId: number }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const targetId = `feedcurve_id=${feedCurveId}`

  useEffect(() => {
    dispatch(dispatchFetchByFilter([{ key: "feedcurve_id", ids: [feedCurveId] }]))
  }, [dispatch, feedCurveId])

  const entity = useAppSelector((state) => selectConsumptionById(state, targetId));
  const todayEntity = entity?.consumptions.filter((consumption) => consumption.milestoneDayOffset === 0 && consumption.componentId !== 1);
  const count = entity?.count ?? 0;
  const today = todayEntity?.reduce((agg, consumption) => {
    agg.total += (consumption.total ?? 0)
    agg.progressed += (consumption.progressed ?? 0)
    return agg;
  }, { total: 0, progressed: 0 } as { total: number, progressed: number })


  const fallbackTexts = {
    animalCount: t("negativeParams.animals", { defaultValue: "No Animals" }),
    consumedToday: t("noData", { defaultValue: "No data" })
  };

  const displayData: Record<string, { value?: string | number | JSX.Element; unit?: string }> = {
    animalCount: { value: count ? count : undefined, unit: count === 1 ? t("units.animal", { defaultValue: "animal" }) : t("units.animals", { defaultValue: "animals" }) },
    consumedToday: { value: todayEntity?.length ? <ProgressBar progressed={today.progressed} total={today.total} progressType={ProgressTypes.consumed} /> : undefined, unit: undefined }
  };

  return (
    <CurveInfoBox
      header={t("feedCurvePages.feedCurve.usage", { defaultValue: "current usage" })}
      data={{
        displayData: displayData,
        fallbackTexts: fallbackTexts
      }}
      splitView
    />
  )
})

export default InfoBoxUsage
